export default { sha: '747320e13f523e5bea51a8d8c0e827b4a6658353', buildNumber: 'undefined' }
